const SCROLL_LOCK_CLASS = 'wf-noscroll';
const SCROLL_LOCK_TOP_PROPERTY = '--scroll-lock-top';

export const initNavMenuScrollLock = () => {
  const navButton = document.querySelector('.w-nav-button');

  if (!navButton || typeof MutationObserver === 'undefined') {
    return;
  }

  let scrollPosition = 0;

  const lockScroll = () => {
    scrollPosition = window.scrollY;
    document.documentElement.style.setProperty(
      SCROLL_LOCK_TOP_PROPERTY,
      `${-scrollPosition}px`
    );
    document.documentElement.classList.add(SCROLL_LOCK_CLASS);
  };

  const unlockScroll = () => {
    document.documentElement.classList.remove(SCROLL_LOCK_CLASS);
    document.documentElement.style.removeProperty(SCROLL_LOCK_TOP_PROPERTY);
    window.scrollTo(0, scrollPosition);
  };

  const syncMenuState = () => {
    if (navButton.classList.contains('w--open')) {
      lockScroll();
      return;
    }

    unlockScroll();
  };

  new MutationObserver(syncMenuState).observe(navButton, {
    attributes: true,
    attributeFilter: ['class'],
  });
};
